import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import './stili/token.css';
import './stili/base.css';
import './componenti/componenti.css';

import { App } from './App';
import { avviaBuio } from './lib/buio';
import { avviaContrasto } from './lib/contrasto';
import { Confine } from './aree/accesso/ErroreDiSistema';
import { FornitoreSessione } from './stato/Sessione';

const radice = document.getElementById('radice');
if (!radice) throw new Error('Elemento radice mancante');

/*
 * Il chiaro/scuro prima del primo disegno.
 *
 * Qui e non dentro un componente: la preferenza è dell'applicazione, non del pulsante che
 * la commuta, e applicarla al montaggio di quel pulsante voleva dire applicarla solo nelle
 * schermate che lo contengono — con l'applicazione che cambiava colore navigando.
 */
avviaBuio();
// Il contrasto elevato, per la stessa ragione e nello stesso momento (vedi `contrasto.ts`).
avviaContrasto();

/*
 * Service worker (§ 6). Solo nella build di produzione: in sviluppo terrebbe in cache
 * l'intelaiatura di ieri e ogni modifica sembrerebbe non aver effetto.
 *
 * Se la registrazione non riesce l'applicazione funziona lo stesso: la PWA aggiunge
 * l'installazione sulla home, non è ciò da cui dipende il resto.
 */
/*
 * Dopo una nuova distribuzione i pezzi della versione precedente non esistono più: chi ha
 * l'applicazione aperta da ieri, passando a una schermata mai aperta, chiederebbe un file
 * sparito e vedrebbe un errore. Vite lo segnala con `vite:preloadError`; si ricarica la
 * pagina — una volta sola, perché un file che manca davvero non deve diventare un ciclo.
 */
window.addEventListener('vite:preloadError', (evento) => {
  const CHIAVE = 'poligono.ricaricato-per-versione';
  try {
    if (window.sessionStorage.getItem(CHIAVE) === '1') return;
    window.sessionStorage.setItem(CHIAVE, '1');
  } catch {
    // Archivio non disponibile (navigazione privata): si ricarica lo stesso, una volta.
  }
  evento.preventDefault();
  window.location.reload();
});
window.addEventListener('load', () => {
  // Arrivati fin qui, la versione è quella giusta: il prossimo guasto può ricaricare di nuovo.
  window.setTimeout(() => {
    try {
      window.sessionStorage.removeItem('poligono.ricaricato-per-versione');
    } catch {
      // vedi sopra
    }
  }, 30_000);
});

if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => undefined);
  });
}

createRoot(radice).render(
  <StrictMode>
    <BrowserRouter>
      <FornitoreSessione>
        {/* 6k — un'eccezione in fase di disegno non deve lasciare la pagina bianca. */}
        <Confine>
          <App />
        </Confine>
      </FornitoreSessione>
    </BrowserRouter>
  </StrictMode>,
);
